import React, { useEffect, useState } from 'react';
import {
  Box,
  Button,
  Flex,
  HStack,
  Input,
  Select,
  Table,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tr,
  Badge,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalFooter,
  useDisclosure,
} from '@chakra-ui/react';
import { AddIcon, DownloadIcon } from '@chakra-ui/icons';
import axiosInstance from '../../../api/AxiosInstance';
import FormularioAtractivo from './FormularioAtractivo';

const TablaAtractivos: React.FC = () => {
  const { isOpen: isOpenVer, onOpen: onOpenVer, onClose: onCloseVer } = useDisclosure();
  const { isOpen: isOpenEditar, onOpen: onOpenEditar, onClose: onCloseEditar } = useDisclosure();
  const { isOpen: isOpenNuevo, onOpen: onOpenNuevo, onClose: onCloseNuevo } = useDisclosure();

  const [selectedItem, setSelectedItem] = useState<any>(null);
  const [data, setData] = useState<any[]>([]);
  const [cargando, setCargando] = useState(false);
  const [busqueda, setBusqueda] = useState('');
  const [filtroTipo, setFiltroTipo] = useState('');

  const fetchData = async () => {
    setCargando(true);
    try {
      const res = await axiosInstance.get('/turismo/atractivos');
      setData(res.data || []);
    } catch {
      setData([]);
    } finally {
      setCargando(false);
    }
  };

  useEffect(() => { fetchData(); }, []);

  const datosFiltrados = data.filter((item) => {
    const matchTipo = filtroTipo ? item.tipo === filtroTipo : true;
    const matchBusqueda = busqueda
      ? item.nombre?.toLowerCase().includes(busqueda.toLowerCase()) ||
        item.comunidad?.toLowerCase().includes(busqueda.toLowerCase())
      : true;
    return matchTipo && matchBusqueda;
  });

  const handleVer = (item: any) => { setSelectedItem(item); onOpenVer(); };
  const handleEditar = (item: any) => { setSelectedItem(item); onOpenEditar(); };
  const handleGuardado = () => { onCloseNuevo(); onCloseEditar(); fetchData(); };
  const handleEliminar = async (item: any) => {
    const ok = window.confirm(`Eliminar el atractivo ${item.nombre}?`);
    if (!ok) return;
    try {
      await axiosInstance.delete(`/turismo/atractivos/${item.id}`);
      fetchData();
    } catch {
      // noop
    }
  };

  const handleExport = (format: 'pdf' | 'excel') => {
    const base = axiosInstance.defaults.baseURL || '';
    const url = `${base}/turismo/atractivos/export?format=${format}`;
    window.open(url, '_blank');
  };

  const handlePdf = (id: number) => {
    const base = axiosInstance.defaults.baseURL || '';
    window.open(`${base}/turismo/atractivos/${id}/pdf`, '_blank');
  };

  return (
    <Box>
      <Flex mb={4} justify="space-between" align="center" flexWrap="wrap" gap={3}>
        <HStack spacing={3} flexWrap="wrap">
          <Input
            placeholder="Buscar por nombre o comunidad..."
            value={busqueda}
            onChange={(e) => setBusqueda(e.target.value)}
            size="sm"
            w={{ base: 'full', md: '240px' }}
          />
          <Select
            placeholder="Filtrar por tipo"
            value={filtroTipo}
            onChange={(e) => setFiltroTipo(e.target.value)}
            size="sm"
            w="180px"
          >
            {Array.from(new Set(data.map((d) => d.tipo).filter(Boolean))).map((tipo) => (
              <option key={tipo} value={tipo}>{tipo}</option>
            ))}
          </Select>
        </HStack>
        <HStack spacing={2}>
          <Button size="sm" leftIcon={<DownloadIcon />} colorScheme="green" variant="outline" onClick={() => handleExport('excel')}>
            Excel
          </Button>
          <Button size="sm" leftIcon={<DownloadIcon />} colorScheme="red" variant="outline" onClick={() => handleExport('pdf')}>
            PDF
          </Button>
          <Button size="sm" leftIcon={<AddIcon />} bg="#5b182b" color="white" _hover={{ bg: '#691f30' }} onClick={onOpenNuevo}>
            Nuevo atractivo
          </Button>
        </HStack>
      </Flex>

      <Box overflowX="auto" borderRadius="md" boxShadow="md" bg="white">
        <Table variant="simple" size="sm">
          <Thead bg="#5b182b">
            <Tr>
              <Th color="white" fontSize="xs">Nombre</Th>
              <Th color="white" fontSize="xs">Tipo</Th>
              <Th color="white" fontSize="xs">Comunidad</Th>
              <Th color="white" fontSize="xs">Costo</Th>
              <Th color="white" fontSize="xs">Estatus</Th>
              <Th color="white" fontSize="xs">Acciones</Th>
            </Tr>
          </Thead>
          <Tbody>
            {cargando ? (
              <Tr><Td colSpan={6} textAlign="center" py={8}><Text color="gray.500">Cargando...</Text></Td></Tr>
            ) : datosFiltrados.length === 0 ? (
              <Tr><Td colSpan={6} textAlign="center" py={8}><Text color="gray.400">Sin registros</Text></Td></Tr>
            ) : (
              datosFiltrados.map((item, idx) => (
                <Tr key={item.id} bg={idx % 2 === 0 ? 'white' : 'gray.50'} _hover={{ bg: '#f7efe8' }}>
                  <Td maxW="220px"><Text noOfLines={1} title={item.nombre}>{item.nombre}</Text></Td>
                  <Td>{item.tipo}</Td>
                  <Td>{item.comunidad || '-'}</Td>
                  <Td>{item.costo || '-'}</Td>
                  <Td><Badge colorScheme={item.estatus === 'activo' ? 'green' : 'gray'}>{item.estatus}</Badge></Td>
                  <Td>
                    <HStack spacing={1}>
                      <Button size="xs" colorScheme="blue" variant="outline" onClick={() => handleVer(item)}>Ver</Button>
                      <Button size="xs" colorScheme="orange" variant="outline" onClick={() => handleEditar(item)}>Editar</Button>
                      <Button size="xs" colorScheme="purple" variant="outline" onClick={() => handlePdf(item.id)}>PDF</Button>
                      <Button size="xs" colorScheme="red" variant="outline" onClick={() => handleEliminar(item)}>Eliminar</Button>
                    </HStack>
                  </Td>
                </Tr>
              ))
            )}
          </Tbody>
        </Table>
      </Box>

      <Modal isOpen={isOpenVer} onClose={onCloseVer} size="6xl" scrollBehavior="inside">
        <ModalOverlay />
        <ModalContent borderRadius="xl" overflow="hidden">
          <ModalHeader borderBottom="1px solid" borderColor="gray.200" color="#5b182b" bg="#f7efe8">Detalle del atractivo</ModalHeader>
          <ModalBody py={5} bg="white">
            {selectedItem && <FormularioAtractivo modo="view" data={selectedItem} />}
          </ModalBody>
          <ModalFooter borderTop="1px solid" borderColor="gray.100" bg="gray.50">
            <Button onClick={onCloseVer}>Cerrar</Button>
          </ModalFooter>
        </ModalContent>
      </Modal>

      <Modal isOpen={isOpenEditar} onClose={onCloseEditar} size="6xl" scrollBehavior="inside">
        <ModalOverlay />
        <ModalContent borderRadius="xl" overflow="hidden">
          <ModalHeader borderBottom="1px solid" borderColor="gray.200" color="#5b182b" bg="#f7efe8">Editar atractivo</ModalHeader>
          <ModalBody py={5} bg="white">
            {selectedItem && <FormularioAtractivo modo="edit" data={selectedItem} onGuardado={handleGuardado} onCancelar={onCloseEditar} />}
          </ModalBody>
        </ModalContent>
      </Modal>

      <Modal isOpen={isOpenNuevo} onClose={onCloseNuevo} size="6xl" scrollBehavior="inside">
        <ModalOverlay />
        <ModalContent borderRadius="xl" overflow="hidden">
          <ModalHeader borderBottom="1px solid" borderColor="gray.200" color="#5b182b" bg="#f7efe8">Nuevo atractivo</ModalHeader>
          <ModalBody py={5} bg="white">
            <FormularioAtractivo modo="new" onGuardado={handleGuardado} onCancelar={onCloseNuevo} />
          </ModalBody>
        </ModalContent>
      </Modal>
    </Box>
  );
};

export default TablaAtractivos;

